import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDynComponentHost]',
})
export class DynComponentHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
